"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPlacement = void 0;
var NotificationPlacement;
(function (NotificationPlacement) {
    NotificationPlacement["NotificationMid"] = "notification_mid";
    NotificationPlacement["NotificationTop"] = "notification_top";
})(NotificationPlacement = exports.NotificationPlacement || (exports.NotificationPlacement = {}));
